// Copyright (c) 2025, Quantum Xchange, Inc
'use strict'

import { useMutation } from '@tanstack/react-query'
import axios from 'axios'

export const useChangePasswordMutation = (useMutationParams = {}) =>
    useMutation({
        mutationFn: async params =>
            await axios.put(
                `/users/${params.uid}/changePassword`,
                {
                    username: params.username,
                    currentPassword: params.currentPassword,
                    newPassword: params.newPassword,
                },
                params.axiosConfig
            ),
        ...useMutationParams,
    })
